<template>
  <b-card style="width: 100%" align="left">
    <template v-slot:header>
    </template>
    <b-row>
      <b-col lg="2" style="margin-bottom: 20px">
        <b-button @click="backByOneRecord" variant="outline-primary">
          <b-icon icon="chevron-left" variant="success"></b-icon>
          Назад
        </b-button>
      </b-col>
      <b-col lg="10"></b-col>
    </b-row>
    <b-row>
      <b-col lg="4">
        <b-pagination
            v-model="currentPage"
            :total-rows="rows"
            :per-page="perPage"
            aria-controls="my-table"
        ></b-pagination>
      </b-col>
      <b-col lg="2">
        Страница: {{ currentPage }}
      </b-col>
      <b-col lg="2">
        <b-form-select
            v-model="perPage"
            :options="options">
        </b-form-select>
      </b-col>
      <b-col lg="4">
        <b-button
            @click="downloadCsv"
            variant="outline-primary">
          Скачать все анкеты</b-button>
      </b-col>
    </b-row>
    <b-row>
      <b-col lg="12" style="overflow: auto;">
        <b-table
            sticky-header="700px"
            head-variant="light"
            striped
            hover
            bordered
            :per-page="perPage"
            :current-page="currentPage"
            :items="items"
            :fields="fields">
          <template v-slot:head()="data">
            <div class="hearedStyl"></div>
            <b-button variant="link" :id="data.column">
              {{data.column}}
            </b-button>
            <b-tooltip :target="data.column" triggers="hover">
              {{ data.label }}
            </b-tooltip>
          </template>
          <template v-slot:cell(id)="row">
            <b-button @click="openAnswer(row.item.id)" variant="link">Подробнее</b-button>
          </template>
        </b-table>
      </b-col>
    </b-row>
    <b-row>
      <b-col lg="4">
        <b-pagination
            v-model="currentPage"
            :total-rows="rows"
            :per-page="perPage"
            aria-controls="my-table"
        ></b-pagination>
      </b-col>
      <b-col lg="4">
        Страница: {{ currentPage }}
      </b-col>
      <b-col lg="4">
        <b-form-select
            v-model="perPage"
            :options="options">
        </b-form-select>
      </b-col>
    </b-row>
    <template v-slot:footer>
      <b-container  class="text-right">
        <small>© Customer Service 2020</small>
      </b-container>
    </template>
  </b-card>
</template>

<script>
import RestApi from '../store/RestApi'
// import DataThisIsPub from './DataThisIsPub'
import _ from 'lodash'
import moment from 'moment'
import DataCat from './DataEmployee'

export default {
  name: 'AnswersBy',
  data () {
    return {
      options: [
        { value: 10, text: '10' },
        { value: 25, text: '25' },
        { value: 50, text: '50' },
        { value: 75, text: '75' },
        { value: 100, text: '100' }
      ],
      perPage: 25,
      currentPage: 1,
      fields: [
        { key: 'id', label: 'Id', sortable: false }
      ],
      items: [],
      schemaForms: DataCat.getConfig(),
      nameFields: ''
    }
  },
  mounted () {
    const api = new RestApi();
    if (this.$route.params.token === api.tokenAuth) {
      this.downloadsData()
    }
  },
  computed: {
    rows () {
      return this.items.length
    }
  },
  methods: {
    toTimeZone (time) {
      // const zone = moment.tz.guess()
      const format = 'YYYY/MM/DD HH:mm'
      return moment(time, format).add(2, 'hours').format(format)
    },
    downloadCsv () {
      const schemaId = this.$route.params.schemaId
      if (this.nameFields === '') {
        this.nameFields = _.map(this.fields, 'key')
      }
      const url = `${RestApi.remoteHost}/api/DownloadAnswersBySchema/${schemaId}/${this.nameFields}`
      window.open(url, '_blank')
    },
    openAnswer (id) {
      this.$router.push({path: `/admin/open_answer/${id}/${this.$route.params.token}`})
    },
    downloadsData () {
      const schemaId = this.$route.params.schemaId
      if (schemaId === 0) {
        return
      }
      this.getConfig(() => {
        RestApi.AnswersBySchema(schemaId).then((response) => {
          this.items = response.data
        }).catch((error) => {
          console.log(error)
        })
      })
    },
    getConfig (cb) {
      let items = []
      _.forEach(this.schemaForms, (page) => {
        items = _.concat(items, page)
      })

      _.forEach(items, (item) => {
        if (item.codeQuestion !== '') {
          switch (item.typeQuestion) {
            case 'textEditorDependOn':
              const key = `${item.codeQuestion}_${item.dependsOn.codeQuestions}`
              const question = _.find(items, {codeQuestion: item.dependsOn.codeQuestions})
              const label = item.textQuestion
                .replace('{textQuestion}', question.textQuestion)
                .replace('{point}', 'XX')
              console.log(key)
              this.fields.push({
                key: key,
                label: label,
                sortable: false })
              break
            case 'multiSelect':
              _.forEach(item.answers, (node) => {
                console.log(node.codeQuestions)
                this.fields.push({
                  key: node.codeQuestions,
                  label: node.text,
                  sortable: true })
              })
              break
            case 'formBalanced':
              _.forEach(item.answers, (nodeB) => {
                console.log(nodeB.codeQuestions)
                this.fields.push({
                  key: nodeB.codeQuestions,
                  label: nodeB.text,
                  sortable: true })
              })
              break
            case 'radio':
            case 'radioHorizontal':
            case 'textEditor':
              console.log(item.codeQuestion)
              this.fields.push({
                key: item.codeQuestion,
                label: item.textQuestion,
                sortable: true })
              break
            default:
              console.log(item.textQuestion)
              break
          }
        }
      })
      cb()
    },
    backByOneRecord () {
      console.log('forwardByOneRecord')
      this.$router.go(-1)
    }
  }
}
</script>

<style scoped>
  .table.b-table>thead>tr>th {
    background-color: white;
    position: sticky;
    position: -webkit-sticky;
    top: 0;
    z-index: 2;
  }
</style>



// WEBPACK FOOTER //
// src/components/AnswersBy.vue